/**
 * `shared/charts` ichki shkala yordamchilari (barrel'dan eksport
 * QILINMAYDI).
 */

/** SVG atributlari va CSS foizlari uchun — suzuvchi nuqta shovqinini kesadi. */
export function yumaloq(qiymat: number): number {
	return Math.round(qiymat * 100) / 100;
}

/**
 * `qiymat / max` ni `[0, 100]` foizga aylantiradi.
 *
 * ⚠️ `max <= 0`, manfiy yoki `NaN` → 0 — `width: NaN%` elementni
 * jimgina yo'qotardi.
 */
export function ulushFoiz(qiymat: number, max: number): number {
	if (!(max > 0 && qiymat > 0)) {
		return 0;
	}

	return yumaloq(Math.min(100, (qiymat / max) * 100));
}

/** Bo'sh holat matni — barcha primitivlarda bir xil ko'rinish. */
export const BOSH_USLUB = { color: "var(--chart-axis)" } as const;
